import { Button, Card, CardBody, CardTitle } from 'reactstrap';
import useCheckMobileScreen from '../../hooks/useCheckMobileScreen';
import CardInfoInterface from '../../interfaces/UtilsInterface';

const CardInfo = (props: CardInfoInterface) => {
  const { isMobile, width } = useCheckMobileScreen();
  const isTablet = width <= 1024 && !isMobile;
  const hideIcon = isMobile || isTablet || (!!props.children && width <= 1440);
  return (
    <Card className="card-stats mb-4 mb-xl-0 h-100" style={isTablet ? { height: 130 } : {}}>
      <CardBody style={{ height: 120, display: 'flex', padding: 0 }}>
        <div
          style={{
            flex: 1,
            minWidth: 0,
            overflow: 'hidden',
            padding: '10px 10px',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <CardTitle
            tag="h5"
            className={`text-uppercase text-muted mb-0 ${!props.children ? 'pb-3' : ''}`}
            style={isMobile || isTablet ? { fontSize: 11 } : { fontSize: 12 }}
          >
            {props.title}
            {hideIcon && props.toggle && (
              <Button onClick={props.toggle} size="sm" style={{ float: 'right', display: 'block' }} className={`mt-n1`}>
                <i className="fas fa-list"></i>
              </Button>
            )}
          </CardTitle>
          {typeof props.count !== 'undefined' ? (
            <>
              <span
                className={`w-100 d-flex justify-content-center big-font text-center mb-0 ${
                  !props.children ? 'mt-1' : ''
                }`}
                style={props?.handleCountClick ? { cursor: 'pointer' } : {}}
                onClick={(event: any) => (props?.handleCountClick ? props.handleCountClick() : event?.preventDefault())}
              >
                {props.count || 0}
              </span>
            </>
          ) : (
            <></>
          )}

          {props.children}
        </div>

        {!hideIcon && (
          <div
            style={{
              width: '50px',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '10px 0px',
              position: 'relative',
              margin: '0 10px',
            }}
          >
            {props.toggle && (
              <Button
                href="#"
                onClick={props.toggle}
                size="sm"
                style={{ display: 'block', position: 'absolute', top: '5px', right: 0, marginRight: 0 }}
              >
                <i className="fas fa-list"></i>
              </Button>
            )}

            <div className={`card-info-icon icon icon-shape ${props.class} text-white rounded-circle shadow`}>
              <i className={`fas ${props.icon}`} />
            </div>
          </div>
        )}
      </CardBody>
    </Card>
  );
};

export default CardInfo;
